"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _react2 = require("@chakra-ui/react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var index = _ref => {
  var {
    children,
    actions,
    bgColor,
    title,
    icon,
    colorScheme,
    titleSize,
    borderSize,
    marginTop
  } = _ref;
  var borderSizeReference = {
    sm: "2px",
    md: "4px",
    lg: "6px",
    xl: "8px"
  };
  return /*#__PURE__*/_react.default.createElement(_react2.Stack, {
    mt: marginTop
  }, /*#__PURE__*/_react.default.createElement(_react2.Flex, null, /*#__PURE__*/_react.default.createElement(_react2.HStack, {
    spacing: "10px"
  }, icon ? /*#__PURE__*/_react.default.createElement(_react2.Circle, {
    size: "40px",
    color: colorScheme,
    borderWidth: "2px",
    borderColor: colorScheme
  }, /*#__PURE__*/_react.default.createElement(_react2.Icon, {
    as: icon,
    w: 7,
    h: 7
  })) : null, /*#__PURE__*/_react.default.createElement(_react2.Heading, {
    size: titleSize,
    color: colorScheme
  }, title)), /*#__PURE__*/_react.default.createElement(_react2.Spacer, null), actions ? actions() : null), /*#__PURE__*/_react.default.createElement(_react2.Box, {
    borderTopWidth: borderSizeReference[borderSize] || "4px",
    borderColor: colorScheme,
    margin: "0"
  }, /*#__PURE__*/_react.default.createElement(_react2.Box, {
    marginTop: "0",
    bgColor: bgColor
  }, children)));
};

var _default = index;
exports.default = _default;